import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  id: "create-booking-shipment-v3-retail",
  class: "flex flex-col h-full relative"
}
const _hoisted_2 = { class: "px-10 py-4 flex flex-row gap-4 items-center border-b border-gray-lp-1400" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "w-6 h-6",
  src: _imports_0,
  alt: "back"
}, null, -1)
const _hoisted_4 = { class: "text-black-lp-200 font-semibold text-xl" }
const _hoisted_5 = {
  key: 1,
  class: "bg-gray-lp-1000 flex-grow-1 h-full px-10 py-2.5 overflow-auto w-full"
}
const _hoisted_6 = {
  class: "overflow-auto",
  style: {"max-height":"91%"}
}
const _hoisted_7 = { class: "flex flex-row w-full gap-2 mb-2" }
const _hoisted_8 = { class: "flex flex-row gap-2 mb-2" }
const _hoisted_9 = {
  key: 3,
  class: "py-1"
}
const _hoisted_10 = { class: "flex flex-row gap-2 mt-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "py-1" }, null, -1)
const _hoisted_12 = { class: "text-14px pt-5 text-black-lp-300 font-bold" }
const _hoisted_13 = { class: "flex items-center justify-center py-3" }
const _hoisted_14 = { class: "text-gray-lp-600 line-through text-14px mr-3" }
const _hoisted_15 = { class: "text-red-lp-100 font-bold text-18px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_FilterClient = _resolveComponent("FilterClient")!
  const _component_SttManualReference = _resolveComponent("SttManualReference")!
  const _component_DetailSender = _resolveComponent("DetailSender")!
  const _component_DetailReceiver = _resolveComponent("DetailReceiver")!
  const _component_CommoditySection = _resolveComponent("CommoditySection")!
  const _component_DeliveryService = _resolveComponent("DeliveryService")!
  const _component_DetailKoli = _resolveComponent("DetailKoli")!
  const _component_InsuranceBanner = _resolveComponent("InsuranceBanner")!
  const _component_SectionUploadPhotoForWeightAdjusment = _resolveComponent("SectionUploadPhotoForWeightAdjusment")!
  const _component_DocInternational = _resolveComponent("DocInternational")!
  const _component_DeliveryType = _resolveComponent("DeliveryType")!
  const _component_SectionFooterBookingV3 = _resolveComponent("SectionFooterBookingV3")!
  const _component_card = _resolveComponent("card")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, { key: 0 }))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("section", _hoisted_1, [
      _createVNode("section", _hoisted_2, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, [
          _hoisted_3
        ]),
        _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1)
      ]),
      (_ctx.isError)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            errorType: _ctx.errorDetail,
            onTryAgain: _ctx.getDetail
          }, null, 8, ["errorType", "onTryAgain"]))
        : (_openBlock(), _createBlock("section", _hoisted_5, [
            _createVNode("section", _hoisted_6, [
              (_ctx.isClient)
                ? (_openBlock(), _createBlock(_component_FilterClient, {
                    key: 0,
                    modelValue: _ctx.form.clientName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.clientName = $event)),
                    isDisabled: true
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_SttManualReference, {
                id: "edit-booking-retail-stt-manual",
                class: "mb-2",
                modelValue: _ctx.form,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form = $event)),
                currentIndex: _ctx.currentIndex,
                "onUpdate:currentIndex": _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentIndex = $event)),
                error: _ctx.error,
                "onUpdate:error": _cache[5] || (_cache[5] = ($event: any) => (_ctx.error = $event)),
                sttNoRefExternalIndex: 1,
                isSttAdjustClient: "",
                configManualStt: _ctx.configRule.manualSttNo,
                configRefExternal: _ctx.configRule.manualSttNo
              }, null, 8, ["modelValue", "currentIndex", "error", "configManualStt", "configRefExternal"]),
              _createVNode(_component_DetailSender, {
                class: "mb-2",
                modelValue: _ctx.form,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form = $event)),
                currentIndex: _ctx.currentIndex,
                "onUpdate:currentIndex": _cache[7] || (_cache[7] = ($event: any) => (_ctx.currentIndex = $event)),
                errors: _ctx.error,
                "onUpdate:errors": _cache[8] || (_cache[8] = ($event: any) => (_ctx.error = $event)),
                senderNameIndex: 2,
                senderPhoneIndex: 3,
                senderAddressIndex: 4,
                saveSenderIndex: 5,
                configName: _ctx.configRule.senderName,
                configPhone: _ctx.configRule.senderPhone,
                configSaveAddress: _ctx.configRule.senderSave,
                configAddress: _ctx.configRule.senderAddress,
                configRule: _ctx.configRule,
                isPhoneCodeSet: true
              }, null, 8, ["modelValue", "currentIndex", "errors", "configName", "configPhone", "configSaveAddress", "configAddress", "configRule"]),
              _createVNode(_component_DetailReceiver, {
                id: "booking-receiver-section",
                class: "mb-2",
                modelValue: _ctx.form,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form = $event)),
                currentIndex: _ctx.currentIndex,
                "onUpdate:currentIndex": _cache[10] || (_cache[10] = ($event: any) => (_ctx.currentIndex = $event)),
                errors: _ctx.error,
                "onUpdate:errors": _cache[11] || (_cache[11] = ($event: any) => (_ctx.error = $event)),
                listKGs: _ctx.form.pieces,
                recipientNameIndex: 6,
                recipientPhoneIndex: 7,
                recipientAddressIndex: 8,
                recipientDistrictIndex: 9,
                recipientPostalCodeIndex: 10,
                saveReceiverIndex: 11,
                configName: _ctx.configRule.recipientName,
                configPhone: _ctx.configRule.recipientPhone,
                configAddress: _ctx.configRule.recipientAddress,
                configDistrict: _ctx.configRule.recipientDistrict,
                configPostalCode: _ctx.configRule.recipientPostalCode,
                configSaveAddress: _ctx.configRule.recipientSave,
                isEditForm: true,
                isPhoneCodeSet: true,
                isErrorRouteNotFound: _ctx.errorRouteNotFound,
                "onUpdate:isErrorRouteNotFound": _cache[12] || (_cache[12] = ($event: any) => (_ctx.errorRouteNotFound = $event))
              }, null, 8, ["modelValue", "currentIndex", "errors", "listKGs", "configName", "configPhone", "configAddress", "configDistrict", "configPostalCode", "configSaveAddress", "isErrorRouteNotFound"]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_CommoditySection, {
                  id: "booking-commodity-section",
                  modelValue: _ctx.form,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form = $event)),
                  currentIndex: _ctx.currentIndex,
                  "onUpdate:currentIndex": _cache[14] || (_cache[14] = ($event: any) => (_ctx.currentIndex = $event)),
                  error: _ctx.error,
                  "onUpdate:error": _cache[15] || (_cache[15] = ($event: any) => (_ctx.error = $event)),
                  commodityIndex: 12,
                  configCommodity: _ctx.configRule.commodity,
                  isEditForm: true
                }, null, 8, ["modelValue", "currentIndex", "error", "configCommodity"]),
                _createVNode(_component_DeliveryService, {
                  id: "booking-delivery-service-section",
                  modelValue: _ctx.form.serviceType,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.serviceType = $event)),
                  woodpacking: _ctx.form.woodpacking,
                  "onUpdate:woodpacking": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.woodpacking = $event)),
                  currentIndex: _ctx.currentIndex,
                  "onUpdate:currentIndex": _cache[18] || (_cache[18] = ($event: any) => (_ctx.currentIndex = $event)),
                  error: _ctx.error,
                  "onUpdate:error": _cache[19] || (_cache[19] = ($event: any) => (_ctx.error = $event)),
                  serviceTypeIndex: 13,
                  originCityCode: _ctx.originCityCode,
                  destination: _ctx.form.destinationCity,
                  isLimited: _ctx.isLimited,
                  isBlacklist: _ctx.isBlacklist,
                  disabledCOD: _ctx.isCODDisabled,
                  disabledDFOD: _ctx.isDFODDisabled,
                  disabled: 
              _ctx.configRule.serviceType?.rule.includes(
                _ctx.configValidationForm.NON_EDITABLE
              )
            ,
                  configDeliveryService: _ctx.configRule.serviceType,
                  clientManagementDetail: _ctx.clientManagementDetail,
                  isEdit: true,
                  isClient: _ctx.isClient
                }, null, 8, ["modelValue", "woodpacking", "currentIndex", "error", "originCityCode", "destination", "isLimited", "isBlacklist", "disabledCOD", "disabledDFOD", "disabled", "configDeliveryService", "clientManagementDetail", "isClient"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_DetailKoli, {
                  destination: _ctx.form.destinationCity,
                  isFirstRender: _ctx.isFirstRender,
                  form: _ctx.form,
                  "onUpdate:form": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form = $event)),
                  pieces: _ctx.form.pieces,
                  "onUpdate:pieces": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.pieces = $event)),
                  currentIndex: _ctx.currentIndex,
                  "onUpdate:currentIndex": _cache[22] || (_cache[22] = ($event: any) => (_ctx.currentIndex = $event)),
                  error: _ctx.error,
                  "onUpdate:error": _cache[23] || (_cache[23] = ($event: any) => (_ctx.error = $event)),
                  showWarningHwsProp: _ctx.showWarningHws,
                  "onUpdate:showWarningHwsProp": _cache[24] || (_cache[24] = ($event: any) => (_ctx.showWarningHws = $event)),
                  listCodActive: _ctx.ccoCodActive,
                  listDfodActive: _ctx.ccoDfodActive,
                  maxPieces: _ctx.maxPieces,
                  insuranceData: _ctx.insuranceData,
                  hwsMinimumData: _ctx.heavyWeightSurchargeMinimumConfigData,
                  goodsPriceIndex: 14,
                  codAmountIndex: 15,
                  insuranceIndex: 16,
                  pieceIndex: 17,
                  formType: _ctx.isCustomerApps ? 'retail' : _ctx.formType,
                  configGoodsPrice: _ctx.configRule.goodsPrice,
                  configInsurance: _ctx.configRule.insurance,
                  configCodAmount: _ctx.configRule.codAmount,
                  configGrossWeight: _ctx.configRule.grossWeight,
                  configDimension: _ctx.configRule.dimension,
                  configAdjustPiece: _ctx.configRule.adjustPiece,
                  tempPieces: _ctx.tempTotalPieces,
                  disabledWeight: _ctx.disabledWeightAdjustment,
                  disabledDimension: _ctx.disabledWeightAdjustment,
                  configAdjustPieceAdd: _ctx.configRule.adjustPieceAdd,
                  configAdjustPieceRemove: _ctx.configRule.adjustPieceRemove,
                  listKgDefault: _ctx.listKGsDefault,
                  isEditForm: true,
                  isEditSttMY: _ctx.isEditSttMY,
                  totalChargeableWeight: _ctx.chargeableWeight,
                  schemaGoodsPriceType: _ctx.schemaGoodsPriceType,
                  insuranceBasic: _ctx.insuranceBasic,
                  isRetail: true,
                  isForceShowInsurance: true,
                  isEdit: true,
                  isCrossCountryRoute: _ctx.isCrossCountryRoute
                }, null, 8, ["destination", "isFirstRender", "form", "pieces", "currentIndex", "error", "showWarningHwsProp", "listCodActive", "listDfodActive", "maxPieces", "insuranceData", "hwsMinimumData", "formType", "configGoodsPrice", "configInsurance", "configCodAmount", "configGrossWeight", "configDimension", "configAdjustPiece", "tempPieces", "disabledWeight", "disabledDimension", "configAdjustPieceAdd", "configAdjustPieceRemove", "listKgDefault", "isEditSttMY", "totalChargeableWeight", "schemaGoodsPriceType", "insuranceBasic", "isCrossCountryRoute"]),
                _createVNode(_component_InsuranceBanner, {
                  type: _ctx.insuranceType,
                  "onUpdate:type": _cache[25] || (_cache[25] = ($event: any) => (_ctx.insuranceType = $event))
                }, null, 8, ["type"])
              ]),
              (_ctx.isShowSectionUpload)
                ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjusment, {
                    key: 1,
                    class: "-mb-3",
                    ref: "section-weight-adjustment",
                    title: _ctx.$t('bookingV3.shipment.weightPieces.uploadWeightProofPhoto'),
                    showViewAdjustment: _ctx.showViewAdjustment,
                    "onUpdate:showViewAdjustment": _cache[26] || (_cache[26] = ($event: any) => (_ctx.showViewAdjustment = $event)),
                    watermark: _ctx.manualBookingData.sttNo,
                    modelValue: _ctx.attachmentImages,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.attachmentImages = $event)),
                    onOnUploadImage: _ctx.onUpload,
                    onOnDeleteImage: _ctx.onRemove,
                    onShowViewAdjustment: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showViewAdjustment = !_ctx.showViewAdjustment))
                  }, null, 8, ["title", "showViewAdjustment", "watermark", "modelValue", "onOnUploadImage", "onOnDeleteImage"]))
                : _createCommentVNode("", true),
              (_ctx.eligibleAdditionalInfo)
                ? (_openBlock(), _createBlock(_component_DocInternational, {
                    key: 2,
                    modelValue: _ctx.form.docInternationalForm,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.form.docInternationalForm = $event)),
                    currentIndex: _ctx.currentIndex,
                    "onUpdate:currentIndex": _cache[30] || (_cache[30] = ($event: any) => (_ctx.currentIndex = $event)),
                    error: _ctx.errorDocInternational,
                    "onUpdate:error": _cache[31] || (_cache[31] = ($event: any) => (_ctx.errorDocInternational = $event)),
                    isFtz: false,
                    internationalDocumentDetailData: _ctx.internationalDocumentDetailData,
                    destinationCityId: _ctx.destinationCity.cityId,
                    originCityId: _ctx.districtDetail.cityId,
                    indexListCommodityCIPL: 16,
                    indexEmail: 17,
                    indexIdNumber: 18,
                    indexTaxNumber: 19,
                    indexShipmentStatus: 20,
                    indexImageBeforePackingUrl: 21,
                    indexImageAfterPackingUrl: 22,
                    indexImageIdUrl: 23,
                    indexImageTaxUrl: 24,
                    onFetchConfig: _ctx.getInternationalDocConfig,
                    configInterCipl: _ctx.configRule.interCipl,
                    configInterIdentityNo: _ctx.configRule.interIdentityNo,
                    configInterTaxNo: _ctx.configRule.interTaxNo,
                    configInterEmail: _ctx.configRule.interEmail,
                    configInterImageTaxNo: _ctx.configRule.interImageTaxNo,
                    configInterImageEmail: _ctx.configRule.interImageEmail,
                    configInterImageBeforePacking: _ctx.configRule.interImageBeforePacking,
                    configInterImageAfterPacking: _ctx.configRule.interImageAfterPacking,
                    configInterDutyTaxTerms: _ctx.configRule.interDutyTaxTerms,
                    isEditSttMY: _ctx.isEditSttMY,
                    isRetail: _ctx.formType === 'manual' ? true : false
                  }, null, 8, ["modelValue", "currentIndex", "error", "internationalDocumentDetailData", "destinationCityId", "originCityId", "onFetchConfig", "configInterCipl", "configInterIdentityNo", "configInterTaxNo", "configInterEmail", "configInterImageTaxNo", "configInterImageEmail", "configInterImageBeforePacking", "configInterImageAfterPacking", "configInterDutyTaxTerms", "isEditSttMY", "isRetail"]))
                : _createCommentVNode("", true),
              (_ctx.isFtzAccount && _ctx.eligibleAdditionalInfo)
                ? (_openBlock(), _createBlock("div", _hoisted_9))
                : _createCommentVNode("", true),
              (_ctx.isFtzAccount)
                ? (_openBlock(), _createBlock(_component_DocInternational, {
                    key: 4,
                    modelValue: _ctx.form.ftzForm,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.form.ftzForm = $event)),
                    currentIndex: _ctx.currentIndex,
                    "onUpdate:currentIndex": _cache[33] || (_cache[33] = ($event: any) => (_ctx.currentIndex = $event)),
                    error: _ctx.errorFtz,
                    "onUpdate:error": _cache[34] || (_cache[34] = ($event: any) => (_ctx.errorFtz = $event)),
                    isFtz: true,
                    indexListCommodityCIPL: 26,
                    indexEmail: 27,
                    indexIdNumber: 28,
                    indexTaxNumber: 29,
                    indexShipmentStatus: 30,
                    indexImageIdUrl: 31,
                    indexImageTaxUrl: 32,
                    indexImageBeforePackingUrl: 33,
                    indexImageAfterPackingUrl: 34,
                    configFtzCipl: _ctx.configRule.ftzCipl,
                    configFtzIdentityNo: _ctx.configRule.ftzIdentityNo,
                    configFtzTaxNo: _ctx.configRule.ftzTaxNo,
                    configFtzEmail: _ctx.configRule.ftzEmail,
                    configFtzImageTaxNo: _ctx.configRule.ftzImageTaxNo,
                    configFtzImageEmail: _ctx.configRule.ftzImageEmail,
                    configFtzImageBeforePacking: _ctx.configRule.ftzImageBeforePacking,
                    configFtzImageAfterPacking: _ctx.configRule.ftzImageAfterPacking,
                    configFtzShipmentStatus: _ctx.configRule.ftzShipmentStatus
                  }, null, 8, ["modelValue", "currentIndex", "error", "configFtzCipl", "configFtzIdentityNo", "configFtzTaxNo", "configFtzEmail", "configFtzImageTaxNo", "configFtzImageEmail", "configFtzImageBeforePacking", "configFtzImageAfterPacking", "configFtzShipmentStatus"]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_DeliveryType, {
                  class: "flex-grow",
                  currentIndex: _ctx.currentIndex,
                  "onUpdate:currentIndex": _cache[35] || (_cache[35] = ($event: any) => (_ctx.currentIndex = $event)),
                  modelValue: _ctx.form.productName,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.form.productName = $event)),
                  isErrorUpselling: _ctx.isErrorUpselling,
                  productIndex: 35,
                  listProduct: _ctx.listProducts,
                  isLoadingUpselling: _ctx.loadingUpsellingData,
                  upsellingData: _ctx.upsellingData,
                  configProductType: _ctx.configRule.productType,
                  configTariff: _ctx.configRule.tariff,
                  formType: _ctx.isCustomerApps ? 'retail' : _ctx.formType,
                  isBookingRetail: _ctx.isCustomerApps ? false : _ctx.formType !== 'client',
                  onRetry: _ctx.getUpsellingData,
                  isEditSttMY: _ctx.isEditSttMY,
                  isEditStt: "",
                  isCustomerApps: _ctx.isCustomerApps
                }, null, 8, ["currentIndex", "modelValue", "isErrorUpselling", "listProduct", "isLoadingUpselling", "upsellingData", "configProductType", "configTariff", "formType", "isBookingRetail", "onRetry", "isEditSttMY", "isCustomerApps"]),
                (_ctx.accountIsNonForeign)
                  ? (_openBlock(), _createBlock(_component_InsuranceBanner, {
                      key: 0,
                      type: "shipment"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_11
            ]),
            _createVNode("section", {
              class: 
          `sticky ${
            _ctx.isSidebarAndBreadcrumbV2 ? 'bottom-6' : 'bottom-3'
          } left-0 bg-white w-full flex z-10`
        
            }, [
              _createVNode(_component_SectionFooterBookingV3, {
                class: "flex-grow",
                formType: _ctx.isCustomerApps ? 'manual' : _ctx.formType,
                productType: "REGPACK",
                paymentMethod: _ctx.paymentMethod,
                "onUpdate:paymentMethod": _cache[37] || (_cache[37] = ($event: any) => (_ctx.paymentMethod = $event)),
                payload: {},
                estimationPrice: _ctx.estimationPriceData,
                totalPiece: _ctx.form.pieces.length,
                totalGrossWeight: _ctx.totalGrossWeight,
                totalDimensionWeight: _ctx.totalVolumeWeight,
                chargeableWeight: _ctx.chargeableWeight,
                totalVolumeWeight: _ctx.totalVolumeWeight,
                isCampaign: false,
                goodsValue: _ctx.form.estimationPrice,
                isErrorEstimation: _ctx.errorEstimationPrice,
                isLoadingEstimation: _ctx.loadingEstimationPrice,
                isCodRetailApplied: 
            _ctx.form.serviceType === 'cod' || _ctx.form.serviceType === 'dfod'
          ,
                formCheckTariff: _ctx.form,
                isValid: _ctx.isFormValid,
                isDisabled: !_ctx.isFormValid,
                idTariff: "id-tariff-booking-v3",
                adjustmentRuleTariff: _ctx.configRuleAdjustStt.config.tariff,
                onSubmit: _ctx.onUpdateBooking,
                onRefresh: _ctx.getEstimationPrice,
                configShowPayment: false,
                isEditSttMY: _ctx.isEditSttMY,
                isCustomerApps: _ctx.isCustomerApps,
                hidePaymentMethod: !!_ctx.manualBookingData.sttShipmentId,
                isEdit: true,
                form: _ctx.form,
                destination: _ctx.form.destinationCity,
                isCrossCountryCod: _ctx.isCrossCountryCod,
                prefixCurrency: _ctx.prefixCurrency
              }, null, 8, ["formType", "paymentMethod", "estimationPrice", "totalPiece", "totalGrossWeight", "totalDimensionWeight", "chargeableWeight", "totalVolumeWeight", "goodsValue", "isErrorEstimation", "isLoadingEstimation", "isCodRetailApplied", "formCheckTariff", "isValid", "isDisabled", "adjustmentRuleTariff", "onSubmit", "onRefresh", "isEditSttMY", "isCustomerApps", "hidePaymentMethod", "form", "destination", "isCrossCountryCod", "prefixCurrency"])
            ], 2)
          ]))
    ], 512), [
      [_vShow, !_ctx.isLoading]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('Perubahan Booking Berhasil !'),
      message: 
      `Detail STT “${_ctx.manualBookingData.sttNo}” ${_ctx.$t(
        'bookingShipment.message.updated'
      )}.`
    ,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8",
      ref: "modal-success-ref",
      customButton: "focus:ring-2 focus:ring-blue"
    }, {
      custom: _withCtx(() => [
        (_ctx.discount.isDiscount)
          ? (_openBlock(), _createBlock(_component_card, {
              key: 0,
              isShadow: false,
              class: "mt-3"
            }, {
              default: _withCtx(() => [
                _createVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t("bookingShipment.error.totalPayment")), 1),
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalBeforeDiscount)), 1),
                  _createVNode("div", _hoisted_15, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalAfterDiscount)), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.isShowModalSuccessBooking]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.closeModalError,
      title: _ctx.$t('Perubahan Booking Gagal !'),
      message: _ctx.errorCause,
      image: "image-modal-failed",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.isShowModalFailedBooking]
    ])
  ], 64))
}